webpackJsonp([59],{

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_javascript_mastodon_locales_en_json__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_javascript_mastodon_locales_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__app_javascript_mastodon_locales_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_javascript_mastodon_locales__ = __webpack_require__(8);
//
// locale_en.js
// automatically generated by generateLocalePacks.js
//



Object(__WEBPACK_IMPORTED_MODULE_2__app_javascript_mastodon_locales__["setLocale"])({ messages: __WEBPACK_IMPORTED_MODULE_0__app_javascript_mastodon_locales_en_json___default.a, localeData: __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en_js___default.a });

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

module.exports = {
	"account.block": "Block @{name}",
	"account.block_domain": "Hide everything from {domain}",
	"account.disclaimer_full": "Information below may reflect the user's profile incompletely.",
	"account.edit_profile": "Edit profile",
	"account.follow": "Follow",
	"account.followers": "Followers",
	"account.follows": "Follows",
	"account.follows_you": "Follows you",
	"account.media": "Media",
	"account.mention": "Target @{name}",
	"account.mute": "Mute @{name}",
	"account.posts": "Posts",
	"account.report": "Report @{name}",
	"account.requested": "Awaiting approval. Click to cancel follow request",
	"account.share": "Share @{name}'s profile",
	"account.unblock": "Unblock @{name}",
	"account.unblock_domain": "Unhide {domain}",
	"account.unfollow": "Unfollow",
	"account.unmute": "Unmute @{name}",
	"account.view_full_profile": "View full profile",
	"boost_modal.combo": "You can press {combo} to skip this next time",
	"bundle_column_error.body": "Something went wrong while loading this component.",
	"bundle_column_error.retry": "Try again",
	"bundle_column_error.title": "Network error",
	"bundle_modal_error.close": "Close",
	"bundle_modal_error.message": "Something went wrong while loading this component.",
	"bundle_modal_error.retry": "Try again",
	"column.blocks": "/etc/block",
	"column.community": "~/www",
	"column.direct": "/var/spool/mail",
	"column.favourites": "/var/less-than-three",
	"column.follow_requests": "/var/requests",
	"column.home": "~",
	"column.mutes": "/etc/mute",
	"column.notifications": "/var/log/messages",
	"column.pins": "/var/pin",
	"column.public": "/var/www",
	"column_back_button.label": "..",
	"column_header.hide_settings": "Hide settings",
	"column_header.moveLeft_settings": "Move column to the left",
	"column_header.moveRight_settings": "Move column to the right",
	"column_header.pin": "Pin",
	"column_header.show_settings": "Show settings",
	"column_header.unpin": "Unpin",
	"column_subheading.navigation": "Navigation",
	"column_subheading.settings": "Settings",
	"compose_form.lock_disclaimer": "[[ This shouldn't be displayed. ]]",
	"compose_form.lock_disclaimer.lock": "locked",
	"compose_form.monologuing": "Monologue mode",
	"compose_form.monologuing_on": "Monologuing is on.",
	"compose_form.placeholder": "Input command.",
	"compose_form.privacy_disclaimer": "[[ This shouldn't be displayed. ]]",
	"compose_form.publish": "$exec",
	"compose_form.publish_loud": "$EXEC",
	"compose_form.sensitive": "Mark media as sensitive",
	"compose_form.spoiler": "Hide text behind warning",
	"compose_form.spoiler_placeholder": "Write your warning here",
	"confirmation_modal.cancel": "Cancel",
	"confirmations.block.confirm": "Block",
	"confirmations.block.message": "Are you sure you want to block {name}?",
	"confirmations.delete.confirm": "Delete",
	"confirmations.delete.message": "Are you sure you want to delete this status?",
	"confirmations.domain_block.confirm": "Hide entire domain",
	"confirmations.domain_block.message": "Are you really, really sure you want to block the entire {domain}? In most cases a few targeted blocks or mutes are sufficient and preferable.",
	"confirmations.mute.confirm": "Mute",
	"confirmations.mute.message": "Are you sure you want to mute {name}?",
	"confirmations.unfollow.confirm": "Unfollow",
	"confirmations.unfollow.message": "Are you sure you want to unfollow {name}?",
	"embed.instructions": "Embed this status on your website by copying the code below.",
	"embed.preview": "Here is what it will look like:",
	"emoji_button.activity": "Activity",
	"emoji_button.flags": "Flags",
	"emoji_button.food": "Food & Drink",
	"emoji_button.label": "Insert emoji",
	"emoji_button.nature": "Nature",
	"emoji_button.objects": "Objects",
	"emoji_button.people": "People",
	"emoji_button.search": "Search...",
	"emoji_button.symbols": "Symbols",
	"emoji_button.travel": "Travel & Places",
	"empty_column.community": "The local timeline is empty. Write something publicly to get the ball rolling!",
	"empty_column.direct": "You don't have any direct messages yet. When you send or receive one, it will show up here.",
	"empty_column.hashtag": "There is nothing in this hashtag yet.",
	"empty_column.home": "You aren't following anyone yet. Visit {public} or use search to get started and meet other users.",
	"empty_column.home.inactivity": "Your home feed is empty. If you have been inactive for a while, it will be regenerated for you soon.",
	"empty_column.home.public_timeline": "the public timeline",
	"empty_column.notifications": "You don't have any notifications yet. Interact with others to start the conversation.",
	"empty_column.public": "There is nothing here! Write something publicly, or manually follow users from other instances to fill it up",
	"follow_request.authorize": "Authorize",
	"follow_request.reject": "Reject",
	"getting_started.appsshort": "Apps",
	"getting_started.faq": "FAQ",
	"getting_started.heading": "/dev/null",
	"getting_started.open_source_notice": "Mastodon is open source software. You can contribute or report issues on GitHub at {github}.",
	"getting_started.userguide": "User Guide",
	"home.column_settings.advanced": "Advanced",
	"home.column_settings.basic": "Basic",
	"home.column_settings.filter_regex": "Filter out by regular expressions",
	"home.column_settings.show_reblogs": "Show reruns",
	"home.column_settings.show_replies": "Show replies",
	"home.settings": "Column settings",
	"lightbox.close": "Close",
	"lightbox.next": "Next",
	"lightbox.previous": "Previous",
	"loading_indicator.label": "Loading...",
	"media_gallery.toggle_visible": "Toggle visibility",
	"missing_indicator.label": "Not found",
	"navigation_bar.blocks": "Blocked users",
	"navigation_bar.community_timeline": "Local timeline",
	"navigation_bar.direct": "Direct messages",
	"navigation_bar.edit_profile": "Edit profile",
	"navigation_bar.favourites": "Saved",
	"navigation_bar.follow_requests": "Follow requests",
	"navigation_bar.info": "About this instance",
	"navigation_bar.logout": "Logout",
	"navigation_bar.mutes": "Muted users",
	"navigation_bar.pins": "Pinned commands",
	"navigation_bar.preferences": "Preferences",
	"navigation_bar.public_timeline": "Federated timeline",
	"notification.favourite": "{name} saved your command",
	"notification.follow": "{name} followed you",
	"notification.mention": "{name} targeted you",
	"notification.reblog": "{name} reran your command",
	"notifications.clear": "Clear notifications",
	"notifications.clear_confirmation": "Are you sure you want to permanently clear all your notifications?",
	"notifications.column_settings.alert": "Desktop notifications",
	"notifications.column_settings.favourite": "Saved commands:",
	"notifications.column_settings.follow": "New followers:",
	"notifications.column_settings.mention": "Targets:",
	"notifications.column_settings.push": "Push notifications",
	"notifications.column_settings.push_meta": "This device",
	"notifications.column_settings.reblog": "Reran commands:",
	"notifications.column_settings.show": "Show in column",
	"notifications.column_settings.sound": "Play sound",
	"onboarding.done": "Done",
	"onboarding.next": "Next",
	"onboarding.page_five.public_timelines": "The local timeline shows public posts from everyone on {domain}. The federated timeline shows public posts from everyone who people on {domain} follow. These are the Public Timelines, a great way to discover new people.",
	"onboarding.page_four.home": "The home timeline shows posts from people you follow.",
	"onboarding.page_four.notifications": "The notifications column shows when someone interacts with you.",
	"onboarding.page_one.federation": "Mastodon is a network of independent servers joining up to make one larger social network. We call these servers instances.",
	"onboarding.page_one.handle": "You are on {domain}, so your full handle is {handle}",
	"onboarding.page_one.welcome": "Welcome to Mastodon!",
	"onboarding.page_six.admin": "Your instance's admin is {admin}.",
	"onboarding.page_six.almost_done": "Almost done...",
	"onboarding.page_six.appetoot": "Bon Appetoot!",
	"onboarding.page_six.apps_available": "There are {apps} available for iOS, Android and other platforms.",
	"onboarding.page_six.github": "Mastodon is free open-source software. You can report bugs, request features, or contribute to the code on {github}.",
	"onboarding.page_six.guidelines": "community guidelines",
	"onboarding.page_six.read_guidelines": "Please read {domain}'s {guidelines}!",
	"onboarding.page_six.various_app": "mobile apps",
	"onboarding.page_three.profile": "Edit your profile to change your avatar, bio, and display name. There, you will also find other preferences.",
	"onboarding.page_three.search": "Use the search bar to find people and look at hashtags, such as {illustration} and {introductions}. To look for a person who is not on this instance, use their full handle.",
	"onboarding.page_two.compose": "Write posts from the compose column. You can upload images, change privacy settings, and add content warnings with the icons below.",
	"onboarding.skip": "Skip",
	"privacy.change": "Adjust status privacy",
	"privacy.direct.long": "Post to targeted users only",
	"privacy.direct.short": "Direct",
	"privacy.private.long": "Post to followers only",
	"privacy.private.short": "Followers-only",
	"privacy.public.long": "Post to public timelines",
	"privacy.public.short": "Public",
	"privacy.unlisted.long": "Do not post to public timelines",
	"privacy.unlisted.short": "Unlisted",
	"reply_indicator.cancel": "Cancel",
	"report.placeholder": "Additional comments",
	"report.submit": "Submit",
	"report.target": "Reporting {target}",
	"search.placeholder": "Search",
	"search_results.total": "{count, number} {count, plural, one {result} other {results}}",
	"standalone.public_title": "A look inside...",
	"status.cannot_reblog": "This command cannot be reran",
	"status.delete": "Delete",
	"status.embed": "Embed",
	"status.favourite": "Save",
	"status.load_more": "Load more",
	"status.media_hidden": "Media hidden",
	"status.mention": "Target @{name}",
	"status.mute_conversation": "Mute conversation",
	"status.open": "Expand this status",
	"status.pin": "Pin on profile",
	"status.reblog": "Rerun",
	"status.reblogged_by": "{name} reran",
	"status.reply": "Reply",
	"status.replyAll": "Reply to thread",
	"status.report": "Report @{name}",
	"status.sensitive_toggle": "Click to view",
	"status.sensitive_warning": "Sensitive content",
	"status.share": "Share",
	"status.show_less": "Show less",
	"status.show_more": "Show more",
	"status.unmute_conversation": "Unmute conversation",
	"status.unpin": "Unpin from profile",
	"tabs_bar.compose": "Compose",
	"tabs_bar.direct": "Messages",
	"tabs_bar.federated_timeline": "Federated",
	"tabs_bar.home": "Home",
	"tabs_bar.local_timeline": "Local",
	"tabs_bar.notifications": "Notifications",
	"tools.string_rotate": "ROT13 text",
	"upload_area.title": "Drag & drop to upload",
	"upload_button.label": "Add media",
	"upload_form.undo": "Undo",
	"upload_progress.label": "Uploading...",
	"video.close": "Close video",
	"video.exit_fullscreen": "Exit full screen",
	"video.expand": "Expand video",
	"video.fullscreen": "Full screen",
	"video.hide": "Hide video",
	"video.mute": "Mute sound",
	"video.pause": "Pause",
	"video.play": "Play",
	"video.unmute": "Unmute sound",
	"video_player.expand": "Expand video",
	"video_player.toggle_sound": "Toggle sound",
	"video_player.toggle_visible": "Toggle visibility",
	"video_player.video_error": "Video could not be played"
};

/***/ })

},[698]);


// WEBPACK FOOTER //
// locale_en-6005b37fc558cf4976f6.js